"use strict";
const THROW_TEXT_1_ARGUMENT = 'First argument must be a function';
const THROW_TEXT_STAY_ARGUMENT = '"stay" parameter must by a function';

const configElements = [
	'stay',
	'logs',
];

module.exports = class {
	/**
	 * Create wrapper for a function that returns a promise. Uses to throttle frequent or repeated calls.
	 * @constructor Throttled
	 * @param {function} fn - function that returns a promise
	 * @param {object} [config] - config object
	 * @param {function} [config.stay=function(){return false}] - function that checks is `fn` invokes is necessary
	 * @param {*} [config.logs] - determines is internal logs needed
	 * @example
	 * const Throttled = require('throttled-async');
	 *
	 * const config = {}
	 *
	 * const fn = (params) => new Promise((resolve, reject) => setTimeout(() => resolve(params), 100));
	 *
	 * let throttled = new Throttled(fn, config);
	 * let params = {};
	 * const r1 = throttled.run(params); // will invoke `fn` and return Promise
	 * const r2 = throttled.run(params); // will return old Promise
	 *
	 * setTimeout(() => {
	 * 	const r3 = throttled.run(params); // will invoke `fn` and return new Promise
	 * }, 300)
	 */
	constructor(fn, config = {}) {
		// config validation
		Object
			.keys(config)
			.forEach((key) => configElements.indexOf(key) === -1 ? console.error(`Unknown key in config: ${key}`) : undefined);

		({
			stay: this.stay = () => false,
			logs: this._logs,
		} = config);

		if (typeof fn === 'function' || fn instanceof Function) {
			this._fn = fn;
		} else {
			throw new Error(THROW_TEXT_1_ARGUMENT)
		}
	}

	/**
	 * invokes fn and returns resulting promise
	 * @param {Object} params - arguments for fn call
	 * @throws {Error} - throws an error if result returned `fn` is not a Promise
	 * @returns {Promise}
	 */
	run(params) {
		return Promise.resolve(this._stay(params) ? undefined : this._fn(params))
			.catch((error) => {
				if (this._logs) {
					console.error('Error with params: ', params);
				}

				throw error;
			});
	}

	/**
	 * getter - returns current `stay` function
	 * @returns {function}
	 */
	get stay() {
		return this._stay
	}

	/**
	 * setter - set new value of `stay` function
	 * @param {function} value
	 * @throws {Error} - throws an error if value is not a function
	 */
	set stay(value) {
		if (!(typeof value === 'function' || value instanceof Function)) {
			throw new Error(THROW_TEXT_STAY_ARGUMENT)
		}
		this._stay = value;
	}
};
